import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {} from 'vue'
import {AgBoxS} from '@/components/ag'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AgBoxS), { css: {
      corner: 6,
      border: '1px solid #EEF1F7',
      bg: 'white',
      typography: 'h9',
      color: 'font',
      dp: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 48,
      cursor: 'pointer',
    } }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})